import React from 'react';
import { Tabs } from 'antd';
import TicketsAnalytics from './TicketsAnalytics';
import CrmAnalytics from './CrmAnalytics';
import TextingAnalytics from './TextingAnalytics';
import CalendarAnalytics from './CalendarAnalytics';

const { TabPane } = Tabs;

interface FeatureAnalyticsDashboardProps {
	onBack: () => void;
}

const FeatureAnalyticsDashboard: React.FC<FeatureAnalyticsDashboardProps> = ({ onBack }) => {
	return (
		<div className="min-h-screen bg-gray-50">
			{/* Consistent Header */}
			<div className="bg-white shadow-sm border-b">
				<div className="max-w-6xl mx-auto px-6 py-4">
					<div className="flex justify-between items-center">
						<div className="flex items-center space-x-6">
							<button
								onClick={onBack}
								className="text-indigo-600 hover:text-indigo-800 font-medium"
							>
								← Back to Admin Dashboard
							</button>
							<h1 className="text-2xl font-bold text-gray-900">Feature Analytics Dashboard</h1>
						</div>
						{/* You can add a logout button or other controls here if needed */}
					</div>
				</div>
			</div>

			{/* Main Content */}
			<div className="max-w-6xl mx-auto p-6">
				<p className="text-gray-600 mb-6">Live user analytics dashboards powered by PostHog.</p>
				<Tabs defaultActiveKey="tickets" type="card">
					<TabPane tab="Tickets" key="tickets">
						<TicketsAnalytics />
					</TabPane>
					<TabPane tab="CRM" key="crm">
						<CrmAnalytics />
					</TabPane>
					<TabPane tab="Texting Agent" key="texting">
						<TextingAnalytics />
					</TabPane>
					<TabPane tab="Calendar" key="calendar">
						<CalendarAnalytics />
					</TabPane>
				</Tabs>
			</div>
		</div>
	);
};

export default FeatureAnalyticsDashboard;
